import client from '../../../apis/client'
import { AxiosPromise } from 'axios'

/**
 * annotator の旗（この紙で見つけた誤り）の API。**この面の書き込みの 2 本目**（1 本目は formatSetting）。
 *
 * 旗は店の報告と同じ OCRError に原版（edit_version=0）付きで入り、翌朝のチェックシートはここから始まる。
 * backend は `reported_by` で店と annotator を割り、**この API が返す・触るのは annotator 起源の行だけ**。
 * 店の旗（Prescription JSON の is_reported）は読みも書きもしない。
 *
 * label の規則は report/labels.ts（店の 4 view と同じ形）。契約は prescription log/293 §4。
 */

export type AnnotatorReports = {
  /** annotator が立てて生きている旗のラベル（立てた順） */
  labels: string[]
}

export type AnnotatorReportInput = {
  label: string
  is_reported: boolean
}

export const getAnnotatorReports = (
  ocrRequestEventId: string
): AxiosPromise<AnnotatorReports> =>
  client.get(`api/annotator/prescriptions/${ocrRequestEventId}/reports/`)

/** 旗を立てる（true）／降ろす（false）。応答は更新後の一覧 */
export const postAnnotatorReport = (
  ocrRequestEventId: string,
  body: AnnotatorReportInput
): AxiosPromise<AnnotatorReports> =>
  client.post(`api/annotator/prescriptions/${ocrRequestEventId}/reports/`, body)
